import TourProductsSortedRepository from '@/js/common/Domain/Repository/TourProductsSorted';

export default class TourProductsSortedHotelRepository extends TourProductsSortedRepository {
    comparator(model1, model2) {
        let currentSortStrategy = this.tourSearchModel.get('sortStrategy');

        if (!this.strategies[currentSortStrategy]) {
            currentSortStrategy = 'priceUp';
        }

        return this.strategies[currentSortStrategy](model1, model2);
    }

    initialize(options, tourSearchModel) {
        this.tourSearchModel = tourSearchModel;
    }
}